import { Formik, FormikErrors, FormikValues } from 'formik';
import React, { useState } from 'react';

import { EmbeddedWidgetProvider } from './hooks/embedded-widget-context';
import { GetData, ModalField, PackagedSchema, SessionStorageKeys } from './types';
import { SectionOfferStrip } from '../../pages/insurance/types';
import WidgetBody from './components/widget-body';

type EmbeddedWidgetProps<T> = {
  getData: GetData<T>;
  getCustomParamValues: () => Record<string, any>;
  getSchema: (errors: FormikErrors<T>) => { packagedSchema: PackagedSchema<T> };
  handleSubmit: (values: T) => void;
  isDestinationPage?: boolean;
  isWidgetActive: boolean;
  modalFields: ModalField[];
  offer?: SectionOfferStrip;
  sessionStorageKeys?: SessionStorageKeys;
  setIsWidgetActive: (value: boolean) => void;
  title: string;
};

const EmbeddedWidget = <T extends FormikValues>({
  getData,
  getCustomParamValues,
  handleSubmit,
  isDestinationPage,
  isWidgetActive,
  modalFields,
  offer,
  getSchema,
  sessionStorageKeys,
  setIsWidgetActive,
  title,
}: EmbeddedWidgetProps<T>) => {
  const [currentWidgetErrors, setCurrentWidgetErrors] = useState<FormikErrors<T>>({});
  const { packagedSchema } = getSchema(currentWidgetErrors);

  return (
    <EmbeddedWidgetProvider<T>
      currentWidgetErrors={currentWidgetErrors}
      getCustomParamValues={getCustomParamValues}
      sessionStorageKeys={sessionStorageKeys}
      setCurrentWidgetErrors={setCurrentWidgetErrors}
      modalFields={modalFields}
    >
      <Formik<T> {...packagedSchema} onSubmit={handleSubmit}>
        <WidgetBody<T>
          getData={getData}
          isWidgetActive={isWidgetActive}
          offer={offer}
          setIsWidgetActive={setIsWidgetActive}
          isDestinationPage={isDestinationPage}
          title={title}
        />
      </Formik>
    </EmbeddedWidgetProvider>
  );
};

export default EmbeddedWidget;
